import { firebaseApp } from "./Config";
import { doc, getFirestore, deleteDoc } from "firebase/firestore";

export const DeleteTemplate = async (templateId: string) => {
	const db = getFirestore(firebaseApp);
	return await deleteDoc(doc(db, "document_templates", templateId));
};
